export default __webpack_public_path__ + "static/media/ng3.2ea7ffea.jpg";